<template>
  <div class="bg-white" style="height:100%" v-if="userData" >
    <div v-if="!isEdit" class="mb-3 d-flex bg-popular-gradients1 ">
      <div class="pl-3 pt-3 pb-2">
        <h3 class="text-white">ユーザー作成</h3>
      </div>
    </div>
    <div v-else class="mb-3 d-flex bg-light-fracture1 justify-content-between">
      <div class="pl-3 pt-3 pb-2">
        <h3>ユーザー編集</h3>
      </div>
      <div class="pr-2 pt-2 pb-2">
        <base-button
        v-if="allowDelete"
          @click="onClickDeleteUser"
          :disabled="isProcess"
          type="neutral"
          icon
          size="sm"
        >
          <span class="btn-inner--icon"
            ><i class="fas fa-trash-alt"></i
          ></span>
          <span class="btn-inner--text">ユーザー削除</span>
        </base-button>

      </div>
    </div>
    <div class="pl-3 pr-3" style="max-width:600px;">
      <el-form ref="form" :rules="rules" :model="userData.user" label-position="top">
        <div class="ml-3">
          <h4>メールアドレス <require-tag /></h4>
          <el-form-item prop="email">
            <el-input name="email" autocomplete="off" placeholder="mail@example.com" v-model="userData.user.email" :disabled="isEdit"></el-input>
          </el-form-item>

          <h4>ユーザー名<require-tag /></h4>
          <el-form-item prop="name">
            <!-- <el-input name="name" placeholder="ユーザー名" v-model="userData.user.name" :disabled="!allowEdit" ></el-input> -->
            <el-input name="name" placeholder="ユーザー名" v-model="userData.user.name"  ></el-input>
          </el-form-item>

          <h4>権限</h4>
          <el-form-item prop="usertype">
            <!-- <el-select
              placeholder=""
              name="usertype"
              v-bind:disabled="isNormal || allowChangePassword"
              v-model="userData.user.usertype" >
              <el-option v-for="item in userTypeist"
                        class="select-primary"
                        :value="item.value"
                        :label="item.name"
                        :key="item.name">
              </el-option>
            </el-select> -->

            <el-select
              placeholder=""
              name="usertype"
              v-model="userData.user.usertype" >
              <el-option v-for="item in userTypeist"
                        class="select-primary"
                        :value="item.value"
                        :label="item.name"
                        :key="item.name">
              </el-option>
            </el-select>
          </el-form-item>

          <el-checkbox v-if="isEdit && allowUserDisable" v-model="isDisable" class="text-primary" label="このユーザーを無効にする" size="large" />
        </div>
      </el-form>

      <el-form ref="form2" :rules="rules" :model="passwordSet" label-position="top">
        <div v-if="!isEdit" class="ml-3">
          <h4>パスワード <require-tag /></h4>
          <el-form-item prop="password">
            <el-input type="password" name="password" placeholder="新しいパスワード" v-model="passwordSet.password" ></el-input>
          </el-form-item>

          <h4>パスワードの確認 <require-tag /></h4>
          <el-form-item prop="confirmPassword">
            <el-input type="password" name="confirmPassword" placeholder="パスワードの確認" v-model="passwordSet.confirmPassword" ></el-input>
          </el-form-item>
        </div>
        <div v-if="isEdit && allowChangePassword" class="ml-3">
          <el-checkbox v-model="changePassword" class="text-primary" label="パスワードを変更する" size="large" />
          <div v-if="changePassword">
            <h4>現在のパスワード <require-tag /></h4>
            <el-form-item prop="currentPassword">
              <el-input type="password" name="currentPassword" autocomplete="off" placeholder="現在のパスワード" v-model="passwordSet.currentPassword" :disabled="!changePassword" ></el-input>
            </el-form-item>

            <h4>新しいパスワード <require-tag /></h4>
            <el-form-item prop="password">
              <el-input type="password" name="password" autocomplete="off" placeholder="新しいパスワード" v-model="passwordSet.password" :disabled="!changePassword" ></el-input>
            </el-form-item>

            <h4>パスワードの確認 <require-tag /></h4>
            <el-form-item prop="confirmPassword">
              <el-input type="password" name="confirmPassword" autocomplete="off" placeholder="パスワードの確認" v-model="passwordSet.confirmPassword" :disabled="!changePassword" ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>

    </div>

    <div class="d-flex mt-4">
      <div class="flex-fill pr-5 pl-5">
        <base-button
          block
          type="secondary"
          @click="cancel"
          >キャンセル</base-button
        >
      </div>
      <div class="flex-fill pr-5 pl-5">
        <base-button
          v-if="!isEdit"
          block
          :disabled="isProcess"
          type="primary"
          @click="makeUser"
          >作成</base-button
        >
        <base-button
          v-if="isEdit && allowEdit"
          block
          :disabled="isProcess"
          type="primary"
          @click="onClickUpdateUser"
          >更新</base-button
        >

      </div>
    </div>
  </div>
  <!-- 確認用モーダル -->
  <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1051 !important;" body-classes="p-0">
    <confirm-modal
      :title="confirm.title"
      :message="confirm.message"
      :leftButtonLabel="confirm.leftButtonLabel"
      :rightButtonLabel="confirm.rightButtonLabel"
      @onClickLeftButton="onClickConfirmLeft"
      @onClickRightButton="onClickConfirmRight"
      />
  </modal>
</template>

<script>

import { defineComponent } from "vue";
import API from "@aws-amplify/api";
import { Auth } from 'aws-amplify'
import UserInfo from "../../appUtils/UserInfo.js";
import UserModel from "../../appModel/users/UserModel"
import { useToast } from "vue-toastification";

import ValidateUtil from "@/appUtils/ValidateUtil"
import ConfirmModal from "@/appViews/InspectMaster/Modal/ConfirmModal"
import CustomizeUtil from "@/appUtils/CustomizeUtil"

export default defineComponent({
  name: "MakeUser",
  props: {
    msg: String,

    userId: String
  },
  /**
   * コンポーネント
   */
  components: {
    ConfirmModal
  },
  data() {
    return {
      maxuser: 20,
      username: "",
      email: "",
      group: "",
      loader: null,
      currentPassword: "",
      password: "",
      firstName: "",
      lastName: "",
      confirmPassword: "",
      editUserId: "",
      userData: null,
      changePassword: false,
      isDisable: false,
      isBackUserList: false,
      isEdit: false,
      fromNavbar: false,
      allowEdit: true,
      allowChangePassword: false,
      allowUserDisable: true,
      allowDelete: false,
      ruleForm: {
        name: '',
      },
      rules: {
        name: [
          { required: true, validator: this.checkName, trigger: 'blur' }
        ],
        email: [
          {required: true, validator: this.checkEmail, trigger: 'blur'},
        ],
        currentPassword: [
          { required: true, validator: this.checkCurrentPassword, trigger: 'blur'},
        ],
        password: [
          { required: true, validator: this.checkPassword, trigger: 'blur'},
        ],
        confirmPassword: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("パスワードの確認が未入力です。"));
              } else if (value !== this.passwordSet.password) {
                callback(new Error("パスワードが一致しません"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      userTypeist: [{value: "0", name: "一般"}, {value: "1", name: "管理者"}],
      languageList: [{value: "ja", name: "日本語"}, {value: "en", name: "English"}],
      modal: {
        isShow: false,
        title: "",
        message: "",
        okLabel: "OK",
        okType: "secondary",
        okCallBack: function() {
          alert(`push Ok`)
          this.modal.isShow = false
        },
        cancelLabel: "キャンセル",
        cancelType: "primary",
        cancelCallBack: function() {
          alert(`push cancel`)
          this.modal.isShow = false
        },
      },
      isNormal: false,
      passwordSet: {
        currentPassword: "",
        password: "",
        confirmPassword: ""
      },
      showConfirm: false,
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      isProcess: false,
      tenantId: "",
      isCustomized: false,
    };
  },
  async mounted() {
    await this.init()

  },
  methods: {
    /**
     * 画面初期表示処理
     */
    async init() {
      try {
        // 編集するユーザID
        const params = this.$store.state.editUserParams
        if (params.editUserId == null && params.createFlg == false){
          // 対象のユーザIDも新規作成フラグもない場合は一覧に戻る
          this.$router.push({
            name: "UserList",
          });
          return
        }

        this.editUserId = params.editUserId
        this.isEdit = !params.createFlg
        this.fromNavbar = params.fromNavbar

        const loginInfo = await this.$root.getUserInfo()

        this.group = loginInfo.group
        this.allowChangePassword = (params.editUserId == loginInfo.sub)


        // ログインユーザ―が一般の場合、権限は変更不可
        const pk = this.group
        const sk = UserModel.createSk(loginInfo.sub)
        const loginUser = await UserModel.getUser({pk: pk, sk: sk}, this.group)

        this.isNormal = !Number(loginUser.user.usertype);

        // 一般ユーザーは自身以外の情報は変更不可
        if (this.isNormal) {
          // 編集IDとログインIDが一致すれば編集可
          this.allowEdit = params.editUserId == loginInfo.sub
        } else {
          // 編集対象ユーザーが自身以外の場合かつ、自身が管理者の場合のみ削除可能とする。
          this.allowDelete = (params.editUserId != loginInfo.sub)
        }

        // 管理者かつ自身以外のユーザであれば無効チェック可能
        this.allowUserDisable = false
        if (loginUser.user.usertype == "1" && params.editUserId != loginInfo.sub) {
          this.allowUserDisable = true
        }

        if (this.isEdit) {
          //更新
          try {
            await this.getUser()

          } catch (e) {
            console.log(`更新データ取得エラー`)
            throw e
          }

        } else {
          //新規

          // 一般つユーザーは新規作成不可
          if (this.isNormal) {
            this.$router.push({
              name: "UserList",
            });
            return
          }
          try {
            await this.newUser()
          } catch (e) {
            console.log(`更新データ取得エラー`)
            throw e
          }
        }
        // ユーザー情報チェック
        if (!this.userData) {
          this.showBottomToast(`ユーザー情報が取得できません。削除済みのユーザーでないか確認してください。`, `error`)
          this.$router.push({
            name: "UserList",
          });
          return
        }

        // タイトルをセット
        let navInfo = this.$store.state.navInfo
        navInfo.title = this.isEdit ? "ユーザー情報の編集" : "新規ユーザーを追加"
        navInfo.description = ""
        this.$store.commit("setNavInfo", navInfo)

        // 確認モーダル
        this.modal.isShow = false;

        this.tenantId = loginInfo.group

        // カスタマイズレコードを取得する
        let customizeRecord = await CustomizeUtil.checkCustomizeRecords(this.tenantId);
        // カスタマイズ機能判定
        this.isCustomized = customizeRecord.key === CustomizeUtil.customizeSumigomu
        if (this.isCustomized) {
          this.maxuser = customizeRecord.maxUser
        }
      } catch (e) {
        this.showBottomToast(`ユーザー情報の取得でエラーが発生しました。`, `error`)
        this.$router.push({
          name: "UserList",
        });
      }

    },
    /**
     * 更新対象のユーザ情報を取得
     */
    async getUser() {
      let userData = await UserModel.getUser({sk: UserModel.createSk(this.editUserId)}, this.group)
      // 削除されている場合は取得しない
      console.log(`getUser ${JSON.stringify(userData)}`)
      if (userData._deleted == true) {
        this.userData = null
        return
      }
      this.userData = userData
      this.isDisable = this.userData.user.status === "0"
    },
    /**
     * 新規ユーザ情報を取得
     */
    async newUser() {
      // const loginInfo = await UserInfo.getUserInfo()
      const loginInfo = await this.$root.getUserInfo()
      let newUserRow = await UserModel.getNewData()

      newUserRow.pk = loginInfo.group

      this.userData = newUserRow
    },
    checkName(rule, value, callback){
      if (ValidateUtil.checkBase(value, callback, 50, true, false, false)) {
        callback()
      }
    },
    /**
     * メールアドレスチェック
     */
    checkEmail(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, true, true, false)) {
        callback()
      }
    },
    /**
     * 現在のパスワードチェック
     */
    checkCurrentPassword(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, true, false, false)) {
        callback()
      }
    },
    /**
     * 新しいパスワードチェック
     */
    checkPassword(rule, value, callback) {
      if (ValidateUtil.checkBase(value, callback, 100, true, false, false)) {
        callback()
      }
    },
    /**
     * ユーザー更新
     */
    async updateUser() {
      try {
        this.isProcess = true
        // 入力値のバリデーション
        this.$refs.form.validate(async function(result) {
          if (!result) {
            this.showBottomToast("入力内容にエラーがあります。", "error")
            return
          }
          // パラメータチェック
          try {
            // 無効フラグの値をセット
            this.userData.user.status = this.isDisable ? "0" : "1"
            // DBを更新
            let updatedData = await UserModel.updateUser(this.userData);
            // console.log(`update User Data ${JSON.stringify(updatedData.data.mczv1UpdateUser, null, "\t")}`)
            if (!updatedData.data.mczv1UpdateUser) {
              throw new Error(`更新失敗`)
            }

            // パスワード変更を行うか
            if (this.changePassword) {
              // パスワード変更処理
              const user = await Auth.currentAuthenticatedUser() // ログイン中のユーザー情報
              await Auth.changePassword(
                user,
                this.passwordSet.currentPassword,
                this.passwordSet.password
              )
            }
            // ユーザー一覧に戻る
            if (!this.fromNavbar) {
              this.$router.push({
                name: "UserList",
              });
            } else {
              this.showBottomToast(`更新しました`, `info`)
            }
            this.hideLoader()
            this.isProcess = false
          } catch (e) {
            this.hideLoader()
            this.showBottomToast(`更新時にエラーが発生しました`, `error`)
            console.log(e)
            this.isProcess = false
          }
        }.bind(this))

      } catch (e) {
        this.hideLoader()
        this.showBottomToast(`更新時にエラーが発生しました`, `error`)
        // console.log(JSON.stringify(e))
        console.log(e)
        this.isProcess = false
        return
      }

    },
    /**
     * ユーザ情報を更新
     */
    async onClickUpdateUser() {
      // 基本項目チェック
      try {
        this.isProcess = true
        // this.loader = this.$loading.show();
        this.showLoader()

        this.$refs.form.validate(async function(result) {
          if (!result) {
            this.showBottomToast("入力内容にエラーがあります。", "error")
            return
          }
          // パスワード関係のチェック
          if (this.changePassword) {
            this.$refs.form2.validate(async function(result2) {
              if (!result2) {
                this.showBottomToast("入力内容にエラーがあります。", "error")
                return
              }

              await this.updateUser()
            }.bind(this))
          } else {
            await this.updateUser()
          }
        }.bind(this))
      } catch (e){
        this.hideLoader()
        this.isProcess = false
      }
    },
    /**
     * キャンセルボタン押下
     */
    cancel(){
      this.$router.push({
        name: "UserList",
      });
    },
    /**
     * 新規ユーザ追加
     */
    async makeUser() {
      // try {
      try {
        this.isProcess = true
        this.showLoader()
        // ユーザー上限チェック
        let list = await UserModel.getUserList(this.group)
        if (list.length >= this.maxuser) {
          this.showBottomToast("作成可能なユーザー数の上限に達しています。", "error")
          this.hideLoader()
          return
        }

        // this.loader = this.$loading.show();
        // バリデーション
        this.$refs.form.validate(async function(result) {
          if (!result) {
            this.showBottomToast("入力内容にエラーがあります。", "error")
            this.hideLoader()
            return
          }
          // パスワード関係のチェック
          this.$refs.form2.validate(async function(result2) {
            if (!result2) {
              this.showBottomToast("入力内容にエラーがあります。", "error")
              this.hideLoader()
              return
            }

            try {

              const apiName = "mczv1restapi";
              const path = "/user"

              const userdata = {
                response: true,
                body: {
                  userName: this.userData.user.email,
                  password: this.passwordSet.password,
                  groupName: this.group,
                  userType: this.userData.user.usertype,
                  userDisplayName: this.userData.user.name,
                  attributes: [
                    { Name: "email", Value: this.userData.user.email },
                    { Name: "email_verified", Value: "true" },
                  ]
                },
              };

              const response = await API.post(apiName, path, userdata);

              const data = response.data;
              if (data.success != "") {

                console.log(`${data}`)
                console.log(`${JSON.stringify(data)}`)
                const errorInfo = data
                switch (errorInfo.code) {
                case "UsernameExistsException":
                  throw {message: 'すでに登録済みのメールアドレスです。'}
                case "InvalidPasswordException":
                  throw {message: 'パスワードは英数8文字以上にしてください。'}
                default:
                  throw {message: errorInfo.message}
                }

              }

              this.userData.user.userId = data.sub
              this.userData.sk = UserModel.createSk(this.userData.user.userId);

              // await UserModel.addUser(this.userData);
            } catch (e) {
              this.showBottomToast(e.message, `error`)
              this.hideLoader()
              this.isProcess = false
              throw e
            }

            // 登録完了後はユーザー一覧へ
            this.$router.push({
              name: "UserList",
            });
            this.isProcess = false
            this.hideLoader()
          }.bind(this))
        }.bind(this))
      } catch (e) {
        this.hideLoader()
        this.isProcess = false
      }
    },

    /**
     * ユーザ―削除ボタンのクリック
     */
    onClickDeleteUser() {

      // 変更確認
      this.confirm.message = `ユーザーを削除します。よろしいですか？`
      this.confirm.leftButtonLabel = "キャンセル"
      this.confirm.rightButtonLabel = "削除する"
      this.confirm.leftButtonFn = function() {
        this.showConfirm = false
      }.bind(this)
      this.confirm.rightButtonFn = function() {
        this.showConfirm = false
        this.deleteUser();
      }.bind(this)
      this.showConfirm = true

    },

    /**
     * ユーザ情報を削除
     * ToDo 現在はDynamoDBの論理削除（CognitoIDは操作なし）
     */
    async deleteUser() {

      try {
        this.isProcess = true
        this.showLoader()
        // this.loader = this.$loading.show();

        // 削除フラグを設定
        // this.userData.user.deleted = true;
        // await UserModel.updateUser

        // 削除APIを実行
        const apiName = "mczv1restapi";
        const path = "/user"

        const userdata = {
          response: true,
          body: {
            sub: this.userData.user.userId,
            userName: this.userData.user.email
          },
        };
        const response = await API.del(apiName, path, userdata);
        const data = response.data;
        if (data.success != "") {

          console.log(`${data}`)
          console.log(`${JSON.stringify(data)}`)
          const errorInfo = data
          throw {message: errorInfo.message}

        }
        // DBの削除フラグ
        // await UserModel.deleteUser(this.userData);
        // if (!this.fromNavbar) {
        //   this.$router.push({
        //     name: "UserList",
        //   });
        // } else {
        //   this.showBottomToast(`削除しました`, `info`)
        // }

      } catch (e) {
        this.showBottomToast(`削除時にエラーが発生しました`, `error`)
        throw e
      } finally {
        this.isProcess = false
        // this.loader.hide()
        // this.loader = null
        this.hideLoader()
      }
      this.$router.push({
        name: "UserList",
      });
    },
    /**
     * メニュークリック時の処理です。
     * @param {String} command クリックしたメニューのコマンド
     */
    handleCommand(command) {
      switch (command) {
      case "deleteUser":
        this.clickDeleteUser();
        break;
      }
    },

    showBottomToast(message, type) {
      this.runToast(message, 'bottom-center', type)
    },

    runToast(message, pos='bottom-center', type) {

      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName:["custome-toast-class"],
        closeButton: false,
        position: pos
      });
    },
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader(isShow = true) {
      if (isShow) {
        this.loader = this.$loading.show();
      } else {
        if (this.loader === null) {
          return;
        }
        this.loader.hide();
        this.loader = null;
      }
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.showLoader(false)
      // loader.hide();
    },
  },
});
</script>

<style></style>
